import React from 'react';
import classNames from 'classnames';
import {
  CSpinner,
} from '@coreui/react';

import './styles.scss';
// eslint-disable-next-line react/prop-types
const Preloader = ({ staticLoader, className, minHeight }) => {
  if (staticLoader) {
    return (
      <div className={classNames(['text-center d-flex align-items-center justify-content-center', className])} style={{ minHeight }}>
        <CSpinner color="primary" size="md" />
      </div>
    );
  }
  return (
    <div className={classNames(['preloader-wrapper bg-light', className])}>
      <CSpinner color="primary" size="md" />
    </div>
  );
};

export default Preloader;
